import { Vector, Image as P5Image } from "p5";
import { CUSTOM_IMAGE_SHAPE } from "../Canvas/Controls/BottomMenu/Shapes/ShapeItems"
import {
  uiSketchProps,
  BrushModes,
  ShapeMode,
  Dictionary,
} from "../TypesAndConstants/types";
import Shape from "./SketchUtilities/Shape";
import { THREE_INST } from "./SketchUtilities/Three/threeSingleton";
import { isSketchActive } from "./SketchUtilities/isSketchActive";
import { getMouseOrientation } from "../getMouseOrientation";
const hashedImages:Dictionary<HTMLImageElement> = {}

const uiSketch = (p: any) => {
  let width: number = 0;
  let height: number = 0;
  let isColorfillMode: boolean = false;
  let isColorSelectMode: boolean = false;
  let locaLocations: Vector[];
  let isPortrait = false;
  let brushType: BrushModes = "pen";
  let mode: ShapeMode = "drag";
  let shapeBrushType: number = -1;
  let bSize: number = 0;
  let currentImage: number = -1;
  let shapeInstance: Shape;
  let isMobile: boolean;
  let images: Dictionary<HTMLImageElement> = {};
  const displayColor = p.color("rgba(25,25,25,.5)");
  const shapeDisplay = new Shape(displayColor);
  let shapePos: Vector = new Vector();
  let three = THREE_INST.getInst();
  let rX = 0;
  let rY = 0;
  let p5Fill: P5Image;
  let p5Select: P5Image;
  let fillCursor = require("../../Assets/paint-fill.png");
  let selectCursor = require("../../Assets/sip-line.png");

  p.updateWithProps = function (props: uiSketchProps) {
    const {
      dimensions,
      brushMode,
      brushSize,
      image,
      shapeType,
      shapeInst,
      locationsArr,
    } = props;

    locaLocations = [...locationsArr];
    images = props.images;
    if (
      dimensions &&
      (dimensions.height !== height || dimensions.width !== width)
    ) {
      height = dimensions.height;
      width = dimensions.width;
      p.resizeCanvas(width, height);
    }

    if (currentImage !== image) {
      currentImage = image;
    }

    if (shapeInstance === undefined && shapeInst !== undefined) {
      shapeInstance = shapeInst;
    }

    if (mode !== props.shapeMode) {
      mode = props.shapeMode;
    }

    if (shapeType !== shapeBrushType) {
      shapeBrushType = shapeType;
    }

    if (isPortrait !== props.isPortrait) {
      isPortrait = props.isPortrait;
    }

    if (isMobile !== props.isMobile) {
      isMobile = props.isMobile;
    }

    if (brushMode !== brushType) {
      brushType = brushMode;
    }

    if (props.isColorfillMode !== isColorfillMode) {
      isColorfillMode = props.isColorfillMode;
    }
    if (props.isColorSelectMode !== isColorSelectMode) {
      isColorSelectMode = props.isColorSelectMode;
    }

    if (brushSize !== bSize) {
      shapeDisplay.setBrushSize(brushSize);
      bSize = brushSize;
    }
  };

  const getCurrentImage = () => {
    if( shapeBrushType === CUSTOM_IMAGE_SHAPE &&
      currentImage !== -1 ) {
      if( hashedImages[currentImage] ) {
        return hashedImages[currentImage]
      }
      let imageInfo =  images[currentImage] 
              ? images[currentImage]
              : undefined;
      if( imageInfo ) {
        var image = new Image();
        image.setAttribute("crossorigin", "anonymous");
        image.src = imageInfo.src
        hashedImages[currentImage] = image;
        return image;
      }
 
    }
    return undefined;
  };

  const mouseIsOnCanvas = (pX: number, pY: number) => {
    return pY < height && pY > 0 && pX < width && pX > 0;
  };

  const shapeHandler = (mouseCoords: { x: number; y: number }) => {
    if (brushType === "shape") {
      p.noStroke();
      shapeDisplay.display(
        displayColor,
        shapeBrushType,
        shapePos,
        mode,
        mouseCoords,
        getCurrentImage()
      );
    }
  };

  p.preload = () => {
    p5Fill = p.loadImage(fillCursor);
    p5Select = p.loadImage(selectCursor);
  };

  p.setup = () => {
    const ctx = p.createCanvas(width, height);
    shapeDisplay.setP5Inst(p);
    shapeDisplay.setContext(ctx);
  };

  p.mousePressed = () => {
    three.obj.isPressed = true;
    if (isColorfillMode) {
      three.obj.fill();
    } else if (isColorSelectMode) {
      three.obj.selectColor();
    } else {
      if (brushType === "shape") {
        const mouseCoords = getMouseOrientation(
          isMobile,
          isPortrait,
          p.mouseX,
          p.mouseY,
          p.height
        );
        shapeDisplay.setIsPressed();
        shapePos.set(mouseCoords.x, mouseCoords.y);
      }
    }
  };

  p.mouseDragged = () => {
    if (brushType === "shape" && !isColorSelectMode && !isColorfillMode) {
      const mouseCoords = getMouseOrientation(
        isMobile,
        isPortrait,
        p.mouseX,
        p.mouseY,
        p.height
      );
      let a = 0;
      if (mode === "rotation") {
        rY = p.lerp(rY, mouseCoords.y - shapePos.y, 0.5);
        rX = p.lerp(rX, mouseCoords.x - shapePos.x, 0.5);
        a = p.atan2(rY, rX);
      }

      if (mode === "drag") {
        rY = p.lerp(rY, mouseCoords.y - p.pmouseY, 0.05);
        rX = p.lerp(rX, mouseCoords.x - p.pmouseX, 0.05);
        a = p.atan2(rY, rX);
      }
      shapeDisplay.rotate(a);
    }
  };

  // Issues all mouseRelease commands
  p.mouseReleased = () => {
    const mouseCoords = getMouseOrientation(
      isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    const isOnCanvas = mouseIsOnCanvas(mouseCoords.x, mouseCoords.y);
    if (
      brushType === "shape" &&
      shapeInstance &&
      !isColorSelectMode &&
      !isColorfillMode
    ) {

      p.noStroke();

      shapeInstance.rotation = shapeDisplay.rotation;
      if (isOnCanvas && isSketchActive()) {

        shapeInstance.display(
          three.obj.currentColor,
          shapeBrushType,
          shapePos,
          mode,
          mouseCoords,
          getCurrentImage()
        );
      }
      shapeDisplay.rotate(0);
      shapeInstance.rotate(0);
    }
    three.obj.mouseRelease(isOnCanvas);
  };

  p.draw = () => {
    const mouseCoords = getMouseOrientation(
      isMobile,
      isPortrait,
      p.mouseX,
      p.mouseY,
      p.height
    );
    p.clear();
    if (isColorfillMode) {
      p.image(p5Fill, mouseCoords.x, mouseCoords.y);
    } else if (isColorSelectMode) {
      p.image(p5Select, mouseCoords.x, mouseCoords.y);
    } else if (locaLocations && locaLocations.length > 0 && !isColorfillMode) {
      locaLocations.forEach((i: any) => {
        p.fill(225, 150, 245);
        p.ellipse(i.x, i.y, 18, 18);
      });
    }
    shapeHandler(mouseCoords);
  };
};
export default uiSketch;
